import React, { forwardRef } from 'react';
import { Input } from '@chakra-ui/react';
import { Field } from '../ui/field';

export const CustomInput = forwardRef(({ label, error, helperText, optionalText, required, uppercase, ...props }, ref) => {
  return (
    <Field 
      label={label} 
      invalid={!!error} 
      errorText={error?.message || error} 
      helperText={helperText} 
      optionalText={optionalText} 
      required={required}
      width="100%"
      mb={4} // Add margin bottom for spacing
    >
      <Input 
        ref={ref} 
        {...props} 
        onChange={(e) => {
          if (uppercase) {
            e.target.value = e.target.value.toUpperCase();
          }
          if (props.onChange) {
            props.onChange(e);
          }
        }}
        padding="12px 16px" // Increased padding
        borderRadius="8px"
        borderColor="gray.300"
        _hover={{ borderColor: "blue.400" }}
        _focus={{ 
          borderColor: "blue.500", 
          boxShadow: "0 0 0 1px #3182ce",
          outline: "none"
        }}
        bg="white"
        fontSize="md"
        height="auto" // Allow height to adjust based on padding
      />
    </Field>
  );
});
